import React, { useRef, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import BackToConsole from "../BackToConsole/BackToConsole";
import axios from "axios";
import { uriConfig } from '../../data/uri';
import PopSnackBar from "../PopSnackBar/PopSnackBar";
import { useAuth0 } from '@auth0/auth0-react';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
import { CardActionArea, Collapse, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';


const NovusProducts = (props) => {
    const { authToken, organisationId, organisationName, ...others } = props;
    const { user } = useAuth0();
    const snackRef = useRef();
    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState([true]);
    const [openRows, setOpenRows] = useState({});

    const fetchNovusProducts = () => {
        const url = uriConfig.url.getNovusProducts;
        const parameters = {
            'user_sub': user.sub
        }
        const headers = {
            'auth-authorization': 'Bearer ' + authToken
        }
        // setUserListLoading(true)
        axios.get(url, { params: parameters, headers: headers })
            .then(function (response) {
                // handle success
                snackRef.current.snackBarOpen({ 'message': "Products loaded" })
                const newProductList = []
                for (let item of response.data) {
                    let productInfo = {
                        "Product": item.label,
                        "Quantity": item.value,
                    }
                    if (item.integrations) {
                        productInfo.Integrations = item.integrations
                    }
                    newProductList.push(productInfo)
                }
                setProductList(newProductList)
                setProductListLoading(false)
            }).catch(function (error) {
                // handle error
                snackRef.current.snackBarOpen({ 'message': error })
                setProductListLoading(false)
                console.log(error);
            });
    };

    const handleToggle = (product) => {
        setOpenRows((prev) => ({ ...prev, [product]: !prev[product] }));
    };

    useEffect(() => {
        fetchNovusProducts();
    }, []);

    return (
        <>
            <Toolbar />
            <Box ml='90px' >
                <Box sx={{
                    marginTop: '5vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}>
                    <Typography variant='body1' color="text.secondary" marginBottom={'20px'}>
                        <strong>Tahola-AI Products</strong>
                    </Typography>
                    <Box sx={{
                        width: '80%'
                    }}>
                        <Box id="go-back">
                            <BackToConsole linkLocation="/managementconsole" />
                        </Box>
                        <Box id='Current Products'>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell/>
                                            <TableCell>Product</TableCell>
                                            <TableCell align="right">Quantity</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {productListLoading ? (
                                            Array.from({ length: 4 }).map((_, index) => (
                                                <TableRow key={index}>
                                                    <TableCell colSpan={3}><Skeleton variant="rectangular" height={35} animation="wave" /></TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            productList.map((row) => (
                                                <React.Fragment key={row.Product}>
                                                    <TableRow>
                                                        <TableCell>
                                                            {row.Integrations?.length > 0 && (
                                                                <IconButton onClick={() => handleToggle(row.Product)}>
                                                                    {openRows[row.Product] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell>{row.Product}</TableCell>
                                                        <TableCell align="right">{row.Quantity}</TableCell>
                                                    </TableRow>
                                                    {row.Integrations?.length > 0 && (
                                                        <TableRow>
                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
                                                                <Collapse in={openRows[row.Product]} timeout="auto" unmountOnExit>
                                                                    <Box margin={1}>
                                                                        <Typography variant="body2" gutterBottom>Integrations:</Typography>
                                                                        <ul>
                                                                            {row.Integrations.map((integration, index) => (
                                                                                <li key={index}>{integration}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </Box>
                                                                </Collapse>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </React.Fragment>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Box align="right">
                            <Card sx={{ maxWidth: 500, marginTop: 10 }} size="small" color="primary" align="center">
                                <CardContent>
                                    <Typography color="primary" gutterBottom variant="h5" component="div">
                                        Interested in more?
                                    </Typography>
                                    <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', padding: '0px 0px 10px 0px' }}>
                                        <Typography variant="body2" color="text.secondary" style={{ marginLeft: '10px', paddingBottom: '30px' }}>
                                            Speak to us about your products:
                                        </Typography>
                                    </Box>
                                    <CardActionArea>
                                        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', padding: '0px 0px 10px 0px' }} onClick={() => window.location = 'tel:08452578920'}>
                                            {/* <CallIcon /> */}
                                            <Typography sx={{ marginLeft: '10px' }} variant="body2" color="text.secondary">
                                                0845 257 8920
                                            </Typography>
                                        </Box>
                                    </CardActionArea>
                                    <CardActionArea>
                                        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', padding: '0px 0px 10px 0px' }} onClick={() => window.location = 'mailto:simon.blackbourne@tahola.com?subject=New Product Request For Tahola-AI&body=How can we help you?'}>
                                            {/* <MailOutlineIcon /> */}
                                            <Typography sx={{ marginLeft: '10px' }} variant="body2" color="text.secondary">
                                                simon.blackbourne@tahola.com
                                            </Typography>
                                        </Box>
                                    </CardActionArea>
                                </CardContent>
                            </Card>
                        </Box>
                        <PopSnackBar ref={snackRef} />
                    </Box>
                </Box>
            </Box>
        </>
    );
}

export default NovusProducts;